import { AppThunk } from '../../../index';
import { unsubscribeFromUserReferrals as actionCreator } from '../reducer';

export const unsubscribeFromUserReferrals =
  (): AppThunk =>
  (dispatch, getState, { firestoreSubscriptions }) => {
    firestoreSubscriptions.userReferralsListener?.();
    dispatch(actionCreator());
  };
